import _forEach from 'lodash/forEach'

import { publicRequest } from '../api/publicRequest'
import { DEFAULT_FEES_STYLE } from '../constants'

export interface IConfigs {
  BASE_URL: string;
  CLIENT_ID: string;
  CLIENT_SECRET: string;
  STRIPE_PUBLISHABLE_KEY: string;
  X_SOURCE_ORIGIN: string;
  FEES_STYLE: string;
  [key: string]: string | number;
}

export const CONFIGS: IConfigs = { FEES_STYLE: DEFAULT_FEES_STYLE } as IConfigs

export const setConfigs = (configs: IConfigs) => {
  _forEach(configs, (value, key) => {
    CONFIGS[key] = value
  })

  publicRequest.setBaseUrl(CONFIGS.BASE_URL)
}
